module.exports = __webpack_public_path__ + "static/img/dd.1bbd311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/dd.png
// module id = mVpa
// module chunks = 0